/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'
import CashBack from 'features/CashBack/CashBack'

export const OrderInfo = props => {
  return (
  <div className='row product-brand pt-3 px-2'>
    <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
      <p className='line-date-order txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        Resgate realizado em: <strong>{moment.utc(props.parentOrder.orderDate).format('DD/MM/YYYY [às] HH[h]mm')}</strong>
      </p>
      <p className='line-value-total txt-body-sm txt-subtitle txt-font-body color-ui-2'>
        {(props.parentOrder &&
          props.parentOrder.vendorOrderModel &&
          props.parentOrder.vendorOrderModel[0].vendorName === 'Compra de Pontos') ||
        props.parentOrder.paymentType === 5 ? (
            <p className='txt-body-sm txt-subtitle  txt-initial txt-font-body color-ui-2'>
              Valor Total em dinheiro: <strong className=' txt-initial'>{`R$ ${props.parentOrder.orderPaymentDetailMoneyAndPoints.valuePurchase}`}</strong>
            </p>
          ) : (
            <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
              {`Valor total em ${props.pointsName}:`} <CatalogCurrencyLabel value={props.parentOrder.totalItems} />
            </p>
          )}
      </p>
      {props.parentOrder &&
      props.parentOrder.vendorOrderModel &&
      props.parentOrder.vendorOrderModel[0].vendorName !== 'Compra de Pontos' &&
      props.parentOrder.orderPaymentDetailMoneyAndPoints &&
      props.parentOrder.orderPaymentDetailMoneyAndPoints.pointsUsedDecimal !== 0 ? (
        <p className='line-complement-value txt-body-sm txt-subtitle txt-font-body color-ui-2'>
          Complemento em dinheiro: <strong>{`R$ ${props.parentOrder.orderPaymentDetailMoneyAndPoints.valuePurchase}`}</strong>
        </p>
        ) : (
          ''
        )}
      {props.parentOrder.orderPromoCodeValue ? (
        <p className='line-discount-coupon txt-body-sm txt-subtitle txt-font-body color-ui-2'>
          {`Desconto em ${props.pointsName}: `}
          <CatalogCurrencyLabel value={props.parentOrder.orderPromoCodeValue} />
        </p>
      ) : (
        ''
      )}
      {props.parentOrder.vendorOrderModel
        ? props.parentOrder.vendorOrderModel.map((element, index) => (
          <div className='line-shipping-value'>
            <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
              {element.totalShippingValue === 0 || element.vendorName === 'Compra de Pontos' ? (
                <p />
              ) : (
                <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                  {props.parentOrder.paymentType === 5 ? (
                    <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                        {`Valor do frete ${element.vendorName}:`} {`R$ ${addZeroes(element.totalShippingCurrencyValue)}`}
                    </p>
                  ) : (
                    <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                        {`Valor do frete ${element.vendorName}:`} <CatalogCurrencyLabel value={element.totalShippingValue} />
                    </p>
                  )}
                </p>
              )}
            </p>
            {(props.parentOrder &&
          props.parentOrder.vendorOrderModel &&
          props.parentOrder.vendorOrderModel[0].vendorName !== 'Compra de Pontos') && props.parentOrder.paymentType === 5 ? (
              <div className='mt-1'>
                <CashBack className='box-cashback row' price={props.parentOrder.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal - (element.totalShippingCurrencyValue || 0)} />
              </div>
            ) : (
              ''
            )}
          </div>
        ))
        : ''}
    </div>
  </div>
)
}

function addZeroes (value) {
  // set everything to at least two decimals; removs 3+ zero decimasl, keep non-zero decimals
  let newValue = value * 1 // removes trailing zeros
  newValue = newValue + '' // casts it to string

  let pos = newValue.indexOf('.')
  if (pos === -1) newValue = newValue + '.00'
  else {
    var integer = newValue.substring(0, pos)
    var decimals = newValue.substring(pos + 1)
    while (decimals.length < 2) decimals = decimals + '0'
    newValue = integer + ',' + decimals
  }
  return newValue.toString().replace('.', ',')
}

OrderInfo.propTypes = {
  parentOrder: PropTypes.object.isRequired,
  pointsName: PropTypes.string
}

const mapStateToProps = ({ onlyCash, catalog: { currencyConfiguration } }) => ({
  pointsName: currencyConfiguration.pointsName,
  onlyCash
})

export default connect(mapStateToProps, null)(OrderInfo)



// WEBPACK FOOTER //
// ./src/features/AboutOrder/OrderInfo.js